var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.375 50C9.375 27.5625 27.5625 9.375 50 9.375C72.4375 9.375 90.625 27.5625 90.625 50C90.625 72.4375 72.4375 90.625 50 90.625C27.5625 90.625 9.375 72.4375 9.375 50ZM50 34.375C50.8288 34.375 51.6237 34.7042 52.2097 35.2903C52.7958 35.8763 53.125 36.6712 53.125 37.5V53.125C53.125 53.9538 52.7958 54.7487 52.2097 55.3347C51.6237 55.9208 50.8288 56.25 50 56.25C49.1712 56.25 48.3763 55.9208 47.7903 55.3347C47.2042 54.7487 46.875 53.9538 46.875 53.125V37.5C46.875 36.6712 47.2042 35.8763 47.7903 35.2903C48.3763 34.7042 49.1712 34.375 50 34.375ZM50 68.75C50.8288 68.75 51.6237 68.4208 52.2097 67.8347C52.7958 67.2487 53.125 66.4538 53.125 65.625C53.125 64.7962 52.7958 64.0013 52.2097 63.4153C51.6237 62.8292 50.8288 62.5 50 62.5C49.1712 62.5 48.3763 62.8292 47.7903 63.4153C47.2042 64.0013 46.875 64.7962 46.875 65.625C46.875 66.4538 47.2042 67.2487 47.7903 67.8347C48.3763 68.4208 49.1712 68.75 50 68.75Z",
    fill: "#F79009"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowWarning);
export default __webpack_public_path__ + "static/media/yellowWarning.383f8a32999d48ca356b2515c9315ebb.svg";
export { ForwardRef as ReactComponent };